export * from './full-layout.component';



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/containers/full-layout/index.ts